import { ScrollText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/ui/feedback";
import { cn } from "@/lib/utils";
import { seesCampaigns } from "@/lib/types";
import { useAuth } from "@/lib/auth";

/**
 * Where the campaign's script is read during a call: a pane of the Phone page that the rep brings
 * up from the phone's rail and puts away again (`softphone/call-panes.tsx`), beside the form when
 * both are on. The platform has no scripts yet, so the pane holds the place and says so, the way
 * the opportunity dialog does for its modules that are not built. It asks the server for nothing.
 */
export function ScriptPane({
  className, bodyClassName,
}: {
  className?: string;
  /** For what is under the header only: the Phone page rules the body off from the form beside
   *  it, and leaves the two headers as one band. */
  bodyClassName?: string;
}) {
  const sees = seesCampaigns(useAuth().user?.role);
  return (
    <section aria-label="Script" className={cn("flex min-h-0 flex-col", className)}>
      {/* The same header the form's pane has, so the two read as a pair when side by side. */}
      <header className="shrink-0 border-b border-border px-4 py-2.5">
        <div className="flex min-h-7 items-center gap-2">
          <h2 className="text-sm font-semibold text-text">Script</h2>
          <Badge tone="outline" size="sm">Coming soon</Badge>
        </div>
      </header>
      <div className={cn("relative flex min-h-0 flex-1 flex-col overflow-y-auto scrollbar-subtle p-4", bodyClassName)}>
        <div className="flex min-h-40 flex-1 items-center justify-center rounded-lg border border-dashed border-border">
          <EmptyState
            icon={ScrollText}
            className="py-8"
            title="Script"
            description={
              <>
                This feature is coming soon.
                <span className="mt-1 block text-text-subtle">
                  {sees
                    ? "The campaign's script will show here while you are on a call."
                    : "The script will show here while you are on a call."}
                </span>
              </>
            }
          />
        </div>
      </div>
    </section>
  );
}
